/**
 * Whether the in-app AI assistant may read HTTP response BODIES.
 *
 * Owner decision 13.09.2026 (MCP board, "Wire the response-privacy gate"):
 * an opt-in switch, default OFF — "response privacy gate should be behind
 * switch so user opts in for that himself". The switch is the preference
 * `aiReadResponses` ("Let AI read responses"), shown in the AI panel header and
 * in Settings → AI chat.
 *
 * Every path that puts a response body in front of the model reads this, and
 * every body that does cross goes through `utils/responseBody.js`'s
 * `getResponseBodyForAi` (or `redactString` for a snippet), so turning the
 * switch on is consent, never a bypass of redaction:
 *
 *   1. `get_last_response`       — hooks/useAiActions.js aiGetLastResponse
 *   2. `run_collection` failures — the model projection in AIChatPanel.js
 *   3. the "Explain" failure prompt — services/ai/failurePrompts.js
 *
 * `send_request` never returned a body to the model and still does not.
 */
import { usePreferencesStore } from '../../store/preferencesStore';

export const AI_READ_RESPONSES_LABEL = 'Let AI read responses';

/** Read live, at the moment a body would cross — never cached. */
export function aiMayReadResponses() {
  try {
    return usePreferencesStore.getState().aiReadResponses === true;
  } catch {
    return false;
  }
}

/** What the model is told instead of a body. */
export const RESPONSE_BODY_WITHHELD_NOTE =
  `Response bodies are withheld: the user has not enabled "${AI_READ_RESPONSES_LABEL}". ` +
  'Ask them to turn it on (AI panel header or Settings → AI chat) if you need the body.';
